const rules = {
    required: (name) => ((val) => !!val || (name + ' is required')),

}

export default rules;
